// Една canvas мярка за удебелените надписи в схемата. Малкият размер
// запазва консервативната мярка за баджовете; fallback-ът остава при caller-а.
const MEASURE_SIZE_PX = 8;
let measureContext: CanvasRenderingContext2D | null | undefined;
let measureFont: string | undefined;
const widthCache = new Map<string, number>();

export function clearTextMetrics() {
  measureFont = undefined;
  widthCache.clear();
}

/** Реална ширина в em с общия UI шрифт; null при липса на canvas. */
export function measureSchemaTextEm(text: string): number | null {
  if (typeof document === "undefined" || navigator.userAgent.includes("jsdom")) {
    return null;
  }
  if (measureContext === undefined) {
    measureContext = document.createElement("canvas").getContext("2d");
  }
  if (!measureContext) return null;

  // Семейството е общо за схемата; useSchemaFonts изчиства и него при зареждане.
  if (measureFont === undefined) {
    const family = getComputedStyle(document.documentElement).fontFamily;
    measureFont = `700 ${MEASURE_SIZE_PX}px ${family}`;
    measureContext.font = measureFont;
  }
  const cached = widthCache.get(text);
  if (cached !== undefined) return cached;

  const width = measureContext.measureText(text).width / MEASURE_SIZE_PX;
  widthCache.set(text, width);
  return width;
}
